import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FavoriteChart } from 'src/app/models/favoriteChart';


@Component({
  selector: 'app-chart-thumbnail',
  templateUrl: './chart-thumbnail.component.html',
  styleUrls: ['./chart-thumbnail.component.scss'],
  imports:[ CommonModule,
      FontAwesomeModule]
})
export class ChartThumbnailComponent  {

  @Output() partClick = new EventEmitter<any>();
  @Input() id:string = "";
  @Input() index:string = "";
  @Input() chart:FavoriteChart | undefined | any;
  @Input() permalink:boolean = true;
  @Input() style:any|null;
  @Input() imgStyle:any|null;

  pClick(){
    this.partClick.emit(this.chart);
  }
  

}
